export const KOMPETEMarketplaceV2ABI = [{
    "inputs": [{"internalType": "address", "name": "protocolFeeRecipient", "type": "address"}],
    "stateMutability": "nonpayable",
    "type": "constructor"
}, {"inputs": [], "name": "ArrayLengthMismatch", "type": "error"}, {
    "inputs": [],
    "name": "ArrayLengthMismatch",
    "type": "error"
}, {"inputs": [], "name": "AuctionEnded", "type": "error"}, {
    "inputs": [],
    "name": "AuctionHasBids",
    "type": "error"
}, {"inputs": [], "name": "AuctionNotActive", "type": "error"}, {
    "inputs": [],
    "name": "AuctionNotEnded",
    "type": "error"
}, {"inputs": [], "name": "BidTooLow", "type": "error"}, {
    "inputs": [],
    "name": "CollectionOfferInvalid",
    "type": "error"
}, {"inputs": [], "name": "DeadlineExpired", "type": "error"}, {
    "inputs": [],
    "name": "ECDSAInvalidSignature",
    "type": "error"
}, {
    "inputs": [{"internalType": "uint256", "name": "length", "type": "uint256"}],
    "name": "ECDSAInvalidSignatureLength",
    "type": "error"
}, {
    "inputs": [{"internalType": "bytes32", "name": "s", "type": "bytes32"}],
    "name": "ECDSAInvalidSignatureS",
    "type": "error"
}, {"inputs": [], "name": "EnforcedPause", "type": "error"}, {
    "inputs": [],
    "name": "ExpectedPause",
    "type": "error"
}, {"inputs": [], "name": "FeeTooHigh", "type": "error"}, {
    "inputs": [],
    "name": "InsufficientBalance",
    "type": "error"
}, {"inputs": [], "name": "InsufficientBalance", "type": "error"}, {
    "inputs": [],
    "name": "InsufficientBalance",
    "type": "error"
}, {"inputs": [], "name": "Invalid", "type": "error"}, {
    "inputs": [],
    "name": "InvalidAddress",
    "type": "error"
}, {"inputs": [], "name": "InvalidAmount", "type": "error"}, {
    "inputs": [],
    "name": "InvalidDeadline",
    "type": "error"
}, {"inputs": [], "name": "InvalidFeeConfiguration", "type": "error"}, {
    "inputs": [],
    "name": "InvalidNonce",
    "type": "error"
}, {"inputs": [], "name": "InvalidPaymentAmount", "type": "error"}, {
    "inputs": [],
    "name": "InvalidPaymentAmount",
    "type": "error"
}, {"inputs": [], "name": "InvalidPaymentAmount", "type": "error"}, {
    "inputs": [],
    "name": "InvalidPrice",
    "type": "error"
}, {"inputs": [], "name": "InvalidRecipient", "type": "error"}, {
    "inputs": [],
    "name": "InvalidShortString",
    "type": "error"
}, {"inputs": [], "name": "InvalidSignature", "type": "error"}, {
    "inputs": [],
    "name": "InvalidSignature",
    "type": "error"
}, {"inputs": [], "name": "InvalidSignature", "type": "error"}, {
    "inputs": [],
    "name": "InvalidTokenContract",
    "type": "error"
}, {"inputs": [], "name": "ListingExpired", "type": "error"}, {
    "inputs": [],
    "name": "ListingExpired",
    "type": "error"
}, {"inputs": [], "name": "ListingNotActive", "type": "error"}, {
    "inputs": [],
    "name": "ListingNotActive",
    "type": "error"
}, {"inputs": [], "name": "ListingNotFound", "type": "error"}, {
    "inputs": [],
    "name": "NotApproved",
    "type": "error"
}, {"inputs": [], "name": "NotApproved", "type": "error"}, {
    "inputs": [],
    "name": "NotAuctionSeller",
    "type": "error"
}, {"inputs": [], "name": "NotListingSeller", "type": "error"}, {
    "inputs": [],
    "name": "NotListingSeller",
    "type": "error"
}, {"inputs": [], "name": "NotOfferCreator", "type": "error"}, {
    "inputs": [],
    "name": "NotOwner",
    "type": "error"
}, {"inputs": [], "name": "OfferExpired", "type": "error"}, {
    "inputs": [],
    "name": "OfferNotActive",
    "type": "error"
}, {"inputs": [], "name": "OfferNotActive", "type": "error"}, {
    "inputs": [{
        "internalType": "address",
        "name": "owner",
        "type": "address"
    }], "name": "OwnableInvalidOwner", "type": "error"
}, {
    "inputs": [{"internalType": "address", "name": "account", "type": "address"}],
    "name": "OwnableUnauthorizedAccount",
    "type": "error"
}, {"inputs": [], "name": "ReentrancyGuardReentrantCall", "type": "error"}, {
    "inputs": [{
        "internalType": "address",
        "name": "token",
        "type": "address"
    }], "name": "SafeERC20FailedOperation", "type": "error"
}, {"inputs": [], "name": "SignatureExpired", "type": "error"}, {
    "inputs": [],
    "name": "SignatureUsed",
    "type": "error"
}, {"inputs": [], "name": "SignatureUsed", "type": "error"}, {
    "inputs": [],
    "name": "SignatureUsed",
    "type": "error"
}, {
    "inputs": [{"internalType": "string", "name": "str", "type": "string"}],
    "name": "StringTooLong",
    "type": "error"
}, {"inputs": [], "name": "TokenContractNotAllowed", "type": "error"}, {
    "inputs": [],
    "name": "TransferFailed",
    "type": "error"
}, {"inputs": [], "name": "TransferFailed", "type": "error"}, {
    "inputs": [],
    "name": "TransferFailed",
    "type": "error"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "auctionId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "address",
        "name": "seller",
        "type": "address"
    }, {"indexed": false, "internalType": "address", "name": "tokenContract", "type": "address"}, {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "tokenIds",
        "type": "uint256[]"
    }, {"indexed": false, "internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "startingPrice",
        "type": "uint256"
    }, {"indexed": false, "internalType": "address", "name": "paymentToken", "type": "address"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "endTime",
        "type": "uint256"
    }, {"indexed": false, "internalType": "bool", "name": "enableTimeExtension", "type": "bool"}],
    "name": "AuctionCreated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "auctionId", "type": "uint256"}, {
        "indexed": false,
        "internalType": "address",
        "name": "winner",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "finalPrice", "type": "uint256"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "protocolFeeAmount",
        "type": "uint256"
    }, {
        "indexed": false,
        "internalType": "uint256",
        "name": "collectionFeeAmount",
        "type": "uint256"
    }, {"indexed": false, "internalType": "uint256", "name": "referralFeeAmount", "type": "uint256"}, {
        "indexed": false,
        "internalType": "address",
        "name": "referrer",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "sellerAmount", "type": "uint256"}],
    "name": "AuctionFinalized",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "auctionId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "address",
        "name": "bidder",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}],
    "name": "BidPlaced",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "collection", "type": "address"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "protocolFee",
        "type": "uint256"
    }, {"indexed": false, "internalType": "uint256", "name": "collectionFee", "type": "uint256"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "referralFee",
        "type": "uint256"
    }, {"indexed": false, "internalType": "bool", "name": "buyerPaysProtocolFee", "type": "bool"}],
    "name": "CollectionFeeConfigUpdated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "buyer", "type": "address"}, {
        "indexed": true,
        "internalType": "address",
        "name": "seller",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
    }, {"indexed": false, "internalType": "uint256", "name": "price", "type": "uint256"}],
    "name": "CollectionOfferExecuted",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "buyer", "type": "address"}, {
        "indexed": true,
        "internalType": "address",
        "name": "tokenContract",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
    }, {"indexed": false, "internalType": "uint256", "name": "price", "type": "uint256"}, {
        "indexed": false,
        "internalType": "address",
        "name": "paymentToken",
        "type": "address"
    }],
    "name": "CollectionOfferExecuted",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "token", "type": "address"}, {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
    }, {"indexed": false, "internalType": "bool", "name": "isNFT", "type": "bool"}],
    "name": "ContractToggled",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": false, "internalType": "uint256", "name": "newFee", "type": "uint256"}],
    "name": "DefaultProtocolFeeUpdated",
    "type": "event"
}, {"anonymous": false, "inputs": [], "name": "EIP712DomainChanged", "type": "event"}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "recipient", "type": "address"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
    }],
    "name": "ETHWithdrawn",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "newRecipient", "type": "address"}],
    "name": "FeeRecipientUpdated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "listingId", "type": "uint256"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "protocolFee",
        "type": "uint256"
    }, {"indexed": false, "internalType": "uint256", "name": "collectionFee", "type": "uint256"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "referralFee",
        "type": "uint256"
    }, {"indexed": false, "internalType": "address", "name": "protocolRecipient", "type": "address"}, {
        "indexed": false,
        "internalType": "address",
        "name": "collectionRecipient",
        "type": "address"
    }, {"indexed": false, "internalType": "address", "name": "referralRecipient", "type": "address"}],
    "name": "FeesPaid",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "seller", "type": "address"}, {
        "indexed": true,
        "internalType": "address",
        "name": "buyer",
        "type": "address"
    }, {"indexed": true, "internalType": "uint256", "name": "listingId", "type": "uint256"}],
    "name": "ItemsSwapped",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "listingId", "type": "uint256"}],
    "name": "ListingCanceled",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "listingId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "address",
        "name": "seller",
        "type": "address"
    }, {
        "indexed": false,
        "internalType": "enum KOMPETETypes.ListingType",
        "name": "listingType",
        "type": "uint8"
    }, {"indexed": false, "internalType": "uint256", "name": "price", "type": "uint256"}],
    "name": "ListingCreated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "listingId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "address",
        "name": "buyer",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "price", "type": "uint256"}],
    "name": "ListingSold",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "listingId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "address",
        "name": "buyer",
        "type": "address"
    }, {"indexed": false, "internalType": "uint256", "name": "price", "type": "uint256"}],
    "name": "ListingSold",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": false, "internalType": "uint256", "name": "newMax", "type": "uint256"}],
    "name": "MaxProtocolFeeUpdated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": false, "internalType": "uint256", "name": "newMax", "type": "uint256"}],
    "name": "MaxTotalFeeUpdated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "offerId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "uint256",
        "name": "listingId",
        "type": "uint256"
    }],
    "name": "OfferAccepted",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "offerId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "uint256",
        "name": "listingId",
        "type": "uint256"
    }],
    "name": "OfferAccepted",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "offerId", "type": "uint256"}],
    "name": "OfferCanceled",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "uint256", "name": "offerId", "type": "uint256"}, {
        "indexed": true,
        "internalType": "uint256",
        "name": "listingId",
        "type": "uint256"
    }, {"indexed": true, "internalType": "address", "name": "buyer", "type": "address"}, {
        "indexed": false,
        "internalType": "uint256",
        "name": "price",
        "type": "uint256"
    }],
    "name": "OfferCreated",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
    }, {"indexed": true, "internalType": "address", "name": "newOwner", "type": "address"}],
    "name": "OwnershipTransferred",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": false, "internalType": "address", "name": "account", "type": "address"}],
    "name": "Paused",
    "type": "event"
}, {
    "anonymous": false,
    "inputs": [{"indexed": false, "internalType": "address", "name": "account", "type": "address"}],
    "name": "Unpaused",
    "type": "event"
}, {
    "inputs": [{"internalType": "uint256", "name": "offerId", "type": "uint256"}],
    "name": "acceptOffer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}],
    "name": "allowedNFTContracts",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "token", "type": "address"}],
    "name": "allowedPaymentTokens",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "auctionCounter",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "auctionId", "type": "uint256"}],
    "name": "cancelAuction",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "offerId", "type": "uint256"}],
    "name": "cancelOffer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "collection", "type": "address"}],
    "name": "collectionFeeConfig",
    "outputs": [{
        "components": [{
            "internalType": "uint256",
            "name": "protocolFee",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "collectionFee", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "referralFee",
            "type": "uint256"
        }, {"internalType": "bool", "name": "buyerPaysProtocolFee", "type": "bool"}, {
            "internalType": "address",
            "name": "collectionOwner",
            "type": "address"
        }], "internalType": "struct KOMPETETypes.FeeConfig", "name": "", "type": "tuple"
    }],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "tokenContract", "type": "address"}, {
        "internalType": "uint256[]",
        "name": "tokenIds",
        "type": "uint256[]"
    }, {"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}, {
        "internalType": "uint256",
        "name": "startingPrice",
        "type": "uint256"
    }, {"internalType": "address", "name": "paymentToken", "type": "address"}, {
        "internalType": "uint256",
        "name": "duration",
        "type": "uint256"
    }, {"internalType": "address", "name": "referrer", "type": "address"}, {
        "internalType": "bool",
        "name": "enableTimeExtension",
        "type": "bool"
    }],
    "name": "createAuction",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "seller", "type": "address"}, {
        "internalType": "address",
        "name": "tokenContract",
        "type": "address"
    }, {"internalType": "uint256[]", "name": "tokenIds", "type": "uint256[]"}, {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
    }, {"internalType": "uint256", "name": "price", "type": "uint256"}, {
        "internalType": "address",
        "name": "paymentToken",
        "type": "address"
    }, {
        "internalType": "enum KOMPETETypes.ListingType",
        "name": "listingType",
        "type": "uint8"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}, {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
    }],
    "name": "createListingWithSignature",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [],
    "name": "defaultBuyerPaysProtocolFee",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "defaultProtocolFee",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "defaultReferralFee",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "eip712Domain",
    "outputs": [{"internalType": "bytes1", "name": "fields", "type": "bytes1"}, {
        "internalType": "string",
        "name": "name",
        "type": "string"
    }, {"internalType": "string", "name": "version", "type": "string"}, {
        "internalType": "uint256",
        "name": "chainId",
        "type": "uint256"
    }, {"internalType": "address", "name": "verifyingContract", "type": "address"}, {
        "internalType": "bytes32",
        "name": "salt",
        "type": "bytes32"
    }, {"internalType": "uint256[]", "name": "extensions", "type": "uint256[]"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{
        "components": [{
            "internalType": "address",
            "name": "buyer",
            "type": "address"
        }, {"internalType": "address", "name": "tokenContract", "type": "address"}, {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
        }, {"internalType": "address", "name": "paymentToken", "type": "address"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "nonce", "type": "uint256"}, {
            "internalType": "bool",
            "name": "used",
            "type": "bool"
        }, {"internalType": "bytes", "name": "signature", "type": "bytes"}],
        "internalType": "struct KOMPETETypes.LazyCollectionOffer",
        "name": "params",
        "type": "tuple"
    }], "name": "executeCollectionOffer", "outputs": [], "stateMutability": "nonpayable", "type": "function"
}, {
    "inputs": [{
        "components": [{"internalType": "address", "name": "seller", "type": "address"}, {
            "internalType": "address",
            "name": "tokenContract",
            "type": "address"
        }, {"internalType": "uint256[]", "name": "tokenIds", "type": "uint256[]"}, {
            "internalType": "uint256[]",
            "name": "amounts",
            "type": "uint256[]"
        }, {"internalType": "uint256", "name": "price", "type": "uint256"}, {
            "internalType": "address",
            "name": "paymentToken",
            "type": "address"
        }, {
            "internalType": "enum KOMPETETypes.ListingType",
            "name": "listingType",
            "type": "uint8"
        }, {"internalType": "address[]", "name": "desiredTokens", "type": "address[]"}, {
            "internalType": "uint256[]",
            "name": "desiredTokenIds",
            "type": "uint256[]"
        }, {"internalType": "uint256[]", "name": "desiredAmounts", "type": "uint256[]"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }, {"internalType": "address", "name": "referrer", "type": "address"}, {
            "internalType": "bytes",
            "name": "signature",
            "type": "bytes"
        }, {"internalType": "bool", "name": "used", "type": "bool"}, {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
        }], "internalType": "struct KOMPETETypes.LazyListing", "name": "params", "type": "tuple"
    }], "name": "executeLazyListing", "outputs": [], "stateMutability": "payable", "type": "function"
}, {
    "inputs": [{
        "components": [{"internalType": "address", "name": "seller", "type": "address"}, {
            "internalType": "address",
            "name": "tokenContract",
            "type": "address"
        }, {"internalType": "uint256[]", "name": "tokenIds", "type": "uint256[]"}, {
            "internalType": "uint256[]",
            "name": "amounts",
            "type": "uint256[]"
        }, {"internalType": "uint256", "name": "price", "type": "uint256"}, {
            "internalType": "address",
            "name": "paymentToken",
            "type": "address"
        }, {
            "internalType": "enum KOMPETETypes.ListingType",
            "name": "listingType",
            "type": "uint8"
        }, {"internalType": "address[]", "name": "desiredTokens", "type": "address[]"}, {
            "internalType": "uint256[]",
            "name": "desiredTokenIds",
            "type": "uint256[]"
        }, {"internalType": "uint256[]", "name": "desiredAmounts", "type": "uint256[]"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }, {"internalType": "address", "name": "referrer", "type": "address"}, {
            "internalType": "bytes",
            "name": "signature",
            "type": "bytes"
        }, {"internalType": "bool", "name": "used", "type": "bool"}, {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
        }], "internalType": "struct KOMPETETypes.LazyListing[]", "name": "lazyListings", "type": "tuple[]"
    }],
    "name": "executeLazyListingBatch",
    "outputs": [{"internalType": "uint256[]", "name": "", "type": "uint256[]"}],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [],
    "name": "feeRecipient",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "auctionId", "type": "uint256"}],
    "name": "finalizeAuction",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "auctionId", "type": "uint256"}], "name": "getAuction", "outputs": [{
        "components": [{"internalType": "address", "name": "seller", "type": "address"}, {
            "internalType": "address",
            "name": "tokenContract",
            "type": "address"
        }, {"internalType": "uint256[]", "name": "tokenIds", "type": "uint256[]"}, {
            "internalType": "uint256[]",
            "name": "amounts",
            "type": "uint256[]"
        }, {"internalType": "uint256", "name": "startingPrice", "type": "uint256"}, {
            "internalType": "address",
            "name": "paymentToken",
            "type": "address"
        }, {"internalType": "uint256", "name": "startTime", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "endTime",
            "type": "uint256"
        }, {"internalType": "address", "name": "highestBidder", "type": "address"}, {
            "internalType": "uint256",
            "name": "highestBid",
            "type": "uint256"
        }, {"internalType": "bool", "name": "active", "type": "bool"}, {
            "internalType": "address",
            "name": "referrer",
            "type": "address"
        }, {"internalType": "uint256", "name": "minBidIncrement", "type": "uint256"}, {
            "internalType": "bool",
            "name": "timeExtensionEnabled",
            "type": "bool"
        }, {"internalType": "uint256", "name": "timeExtensionDuration", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "timeExtensionThreshold",
            "type": "uint256"
        }], "internalType": "struct KOMPETETypes.Auction", "name": "", "type": "tuple"
    }], "stateMutability": "view", "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "tokenContract", "type": "address"}],
    "name": "getFeeConfig",
    "outputs": [{
        "components": [{
            "internalType": "uint256",
            "name": "protocolFee",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "collectionFee", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "referralFee",
            "type": "uint256"
        }, {"internalType": "bool", "name": "buyerPaysProtocolFee", "type": "bool"}, {
            "internalType": "address",
            "name": "collectionOwner",
            "type": "address"
        }], "internalType": "struct KOMPETETypes.FeeConfig", "name": "", "type": "tuple"
    }],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "getMarketplaceInfo",
    "outputs": [{"internalType": "string", "name": "name", "type": "string"}, {
        "internalType": "string",
        "name": "version",
        "type": "string"
    }, {"internalType": "string", "name": "codename", "type": "string"}],
    "stateMutability": "pure",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "listingId", "type": "uint256"}],
    "name": "getPriceWithFees",
    "outputs": [{"internalType": "uint256", "name": "protocolFeeAmount", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "collectionFeeAmount",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "referralFeeAmount", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "finalPrice",
        "type": "uint256"
    }],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "listingId", "type": "uint256"}],
    "name": "instantBuy",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256[]", "name": "listingIds", "type": "uint256[]"}],
    "name": "instantBuyBatch",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "signer", "type": "address"}, {
        "internalType": "bytes32",
        "name": "hash",
        "type": "bytes32"
    }, {"internalType": "bytes", "name": "signature", "type": "bytes"}],
    "name": "isValidSignature",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "listingCounter",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "listingId", "type": "uint256"}],
    "name": "listings",
    "outputs": [{
        "components": [{
            "internalType": "address",
            "name": "seller",
            "type": "address"
        }, {"internalType": "address", "name": "tokenContract", "type": "address"}, {
            "internalType": "uint256[]",
            "name": "tokenIds",
            "type": "uint256[]"
        }, {"internalType": "uint256[]", "name": "amounts", "type": "uint256[]"}, {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
        }, {
            "internalType": "address",
            "name": "paymentToken",
            "type": "address"
        }, {
            "internalType": "enum KOMPETETypes.ListingType",
            "name": "listingType",
            "type": "uint8"
        }, {"internalType": "address[]", "name": "desiredTokens", "type": "address[]"}, {
            "internalType": "uint256[]",
            "name": "desiredTokenIds",
            "type": "uint256[]"
        }, {"internalType": "uint256[]", "name": "desiredAmounts", "type": "uint256[]"}, {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
        }, {"internalType": "bool", "name": "active", "type": "bool"}, {
            "internalType": "address",
            "name": "referrer",
            "type": "address"
        }], "internalType": "struct KOMPETETypes.Listing", "name": "", "type": "tuple"
    }],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "listingId", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "price",
        "type": "uint256"
    }, {"internalType": "address", "name": "paymentToken", "type": "address"}, {
        "internalType": "address[]",
        "name": "offerTokenContracts",
        "type": "address[]"
    }, {"internalType": "uint256[]", "name": "offerTokenIds", "type": "uint256[]"}, {
        "internalType": "uint256[]",
        "name": "offerAmounts",
        "type": "uint256[]"
    }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}],
    "name": "makeOffer",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "payable",
    "type": "function"
}, {
    "inputs": [],
    "name": "maxProtocolFee",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [],
    "name": "maxTotalFee",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}],
    "name": "nonces",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "offerId", "type": "uint256"}],
    "name": "offers",
    "outputs": [{
        "components": [{
            "internalType": "address",
            "name": "buyer",
            "type": "address"
        }, {"internalType": "uint256", "name": "listingId", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
        }, {"internalType": "address", "name": "paymentToken", "type": "address"}, {
            "internalType": "address[]",
            "name": "offerTokenContracts",
            "type": "address[]"
        }, {"internalType": "uint256[]", "name": "offerTokenIds", "type": "uint256[]"}, {
            "internalType": "uint256[]",
            "name": "offerAmounts",
            "type": "uint256[]"
        }, {"internalType": "uint256", "name": "deadline", "type": "uint256"}, {
            "internalType": "bool",
            "name": "active",
            "type": "bool"
        }], "internalType": "struct KOMPETETypes.Offer", "name": "", "type": "tuple"
    }],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}, {
        "internalType": "address",
        "name": "",
        "type": "address"
    }, {"internalType": "uint256[]", "name": "", "type": "uint256[]"}, {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
    }, {"internalType": "bytes", "name": "", "type": "bytes"}],
    "name": "onERC1155BatchReceived",
    "outputs": [{"internalType": "bytes4", "name": "", "type": "bytes4"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}, {
        "internalType": "address",
        "name": "",
        "type": "address"
    }, {"internalType": "uint256", "name": "", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
    }, {"internalType": "bytes", "name": "", "type": "bytes"}],
    "name": "onERC1155Received",
    "outputs": [{"internalType": "bytes4", "name": "", "type": "bytes4"}],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [],
    "name": "owner",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
}, {"inputs": [], "name": "pause", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [],
    "name": "paused",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "auctionId", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "bidAmount",
        "type": "uint256"
    }], "name": "placeBid", "outputs": [], "stateMutability": "payable", "type": "function"
}, {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "collection", "type": "address"}, {
        "internalType": "uint256",
        "name": "protocolFee",
        "type": "uint256"
    }, {"internalType": "uint256", "name": "collectionFee", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "referralFee",
        "type": "uint256"
    }, {"internalType": "bool", "name": "buyerPaysProtocolFee", "type": "bool"}, {
        "internalType": "address",
        "name": "collectionOwner",
        "type": "address"
    }], "name": "setCollectionFeeConfig", "outputs": [], "stateMutability": "nonpayable", "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "newFee", "type": "uint256"}],
    "name": "setDefaultProtocolFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "newMax", "type": "uint256"}],
    "name": "setMaxProtocolFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "uint256", "name": "newMax", "type": "uint256"}],
    "name": "setMaxTotalFee",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "newRecipient", "type": "address"}],
    "name": "setProtocolFeeRecipient",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "contract_", "type": "address"}, {
        "internalType": "bool",
        "name": "isNFT",
        "type": "bool"
    }, {"internalType": "bool", "name": "enabled", "type": "bool"}],
    "name": "toggleContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {
    "inputs": [{"internalType": "address", "name": "newOwner", "type": "address"}],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {"inputs": [], "name": "unpause", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [],
    "name": "withdrawETH",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
}, {"stateMutability": "payable", "type": "receive"}]